var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlSpaFilled = function SvgHtlSpaFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.993 2.148c-1.94 2.6-4.655 8.532 0 11.446 4.655-2.914 1.938-8.846 0-11.446Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.608 12.907a5.455 5.455 0 0 0 1.342-2.716 8.663 8.663 0 0 0-.473-4.394 9.206 9.206 0 0 1 3.918-.875.5.5 0 0 1 .5.437 6.638 6.638 0 0 1-1.435 5.642 6.611 6.611 0 0 1-3.848 1.908l-.004-.002Zm-3.231 0A6.606 6.606 0 0 1 2.53 11a6.633 6.633 0 0 1-1.435-5.642.5.5 0 0 1 .495-.437 9.21 9.21 0 0 1 3.918.875 8.665 8.665 0 0 0-.473 4.394 5.455 5.455 0 0 0 1.342 2.716v.002Z"
  })));
};
export default SvgHtlSpaFilled;